<template lang="pug">
  JobRevisionHeader(title="suspect_code_models")
</template>

<script>
import JobRevisionHeader from '~/components/JobRevisions/Header'
export default {
  components: { JobRevisionHeader }
}
</script>

